<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`内部样品流转单`"
    width="1000px"
    height="800px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <div v-loading="detailLoading">
      <div class="top-code">
        <div>{{ flowSKH }}</div>
        <div>委托编号：{{ entrustData.reportCode }}</div>
      </div>

      <table v-if="entrustData.etmtType == 'etmt_type_unvs'" class="word-table">
        <tr>
          <td colspan="7">
            <span class="label">样品信息描述</span>
          </td>
        </tr>
        <tr>
          <td width="6%" class="label">序号</td>
          <td width="18%" class="label">样品名称</td>
          <td width="12%" class="label">规格型号</td>
          <td width="6%" class="label">单位</td>
          <td width="8%" class="label">数量</td>
          <td width="20%" class="label">生产厂家</td>
          <td width="30%" class="label">样品编号</td>
        </tr>
        <tr v-for="(item, index) in sampleInfoList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.sampleName }}</td>
          <td>{{ item.model }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.cnt }}</td>
          <td>{{ item.manufacturer }}</td>
          <td v-if="item.itemNoMin != item.itemNoMax">{{ item.itemNoMin }} ~ {{ item.itemNoMax }}</td>
          <td v-else>{{ item.itemNoMin }}</td>
        </tr>
      </table>

      <!-- 导线类型 || 预紧绞丝金具 握力实验 -->
      <table v-if="entrustData.etmtType == 'etmt_type_dx' || entrustData.etmtType == 'etmt_type_yjjsjj'" class="word-table">
        <tr>
          <td colspan="9">
            <span class="label">样品信息描述</span>
          </td>
        </tr>
        <tr>
          <td width="6%" class="label">序号</td>
          <td width="14%" class="label">样品名称</td>
          <td width="12%" class="label">规格型号</td>
          <td width="6%" class="label">单位</td>
          <td width="10%" class="label">数量</td>
          <td width="18%" class="label">生产厂家</td>
          <td width="8%" class="label">计算拉断力（kN）</td>
          <td width="8%" class="label">握力值要求（kN）</td>
          <td width="17%" class="label">样品编号</td>
        </tr>
        <tr v-for="(item, index) in sampleInfoList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.sampleName }}</td>
          <td>{{ item.model }}</td>
          <td>根</td>
          <td>{{ item.cnt }}</td>
          <td>{{ item.manufacturer }}</td>
          <td>{{ item.ll }}</td>
          <td>{{ item.wl }}</td>
          <td v-if="item.itemNoMin != item.itemNoMax">{{ item.itemNoMin }} ~ {{ item.itemNoMax }}</td>
          <td v-else>{{ item.itemNoMin }}</td>
        </tr>
      </table>

      <!-- 导线类型 机械载荷实验 -->
      <table v-if="entrustData.etmtType == 'etmt_type_dxph'" class="word-table">
        <tr>
          <td colspan="9">
            <span class="label">样品信息描述</span>
          </td>
        </tr>
        <tr>
          <td width="6%" class="label">序号</td>
          <td width="14%" class="label">样品名称</td>
          <td width="12%" class="label">规格型号</td>
          <td width="6%" class="label">单位</td>
          <td width="10%" class="label">数量</td>
          <td width="18%" class="label">生产厂家</td>
          <td width="8%" class="label">计算拉断力（kN）</td>
          <td width="8%" class="label">握力值要求（kN）</td>
          <td width="17%" class="label">样品编号</td>
        </tr>
        <tr v-for="(item, index) in sampleInfoList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.sampleName }}</td>
          <td>{{ item.model }}</td>
          <td>根</td>
          <td>{{ item.cnt }}</td>
          <td>{{ item.manufacturer }}</td>
          <td>{{ item.ll }}</td>
          <td>{{ item.wl }}</td>
          <td v-if="item.itemNoMin != item.itemNoMax">{{ item.itemNoMin }} ~ {{ item.itemNoMax }}</td>
          <td v-else>{{ item.itemNoMin }}</td>
        </tr>
      </table>

      <table class="word-table">
        <tr>
          <td>
            <span class="label">特殊说明</span>
          </td>
          <td>
            {{ entrustData.note || '/' }}
          </td>
        </tr>
        <tr>
          <td width="20%">
            <span class="label">检测项目</span>
          </td>
          <td width="80%" class="label">依据的标准名称及编号(含年号)</td>
        </tr>
        <tr v-for="(item, index) in tesetItemData" :key="index">
          <td>
            <span>{{ item.itemName }}</span>
          </td>
          <td>{{ item.basisName }}</td>
        </tr>
      </table>

      <table class="word-table">
        <tr>
          <td colspan="4">
            <span class="label">实验室检测情况</span>
          </td>
        </tr>
        <tr>
          <td width="20%" class="label">收样时间</td>
          <td width="30%">
            {{ entrustData.receiptDate }}
          </td>
          <td width="20%" class="label">收样人</td>
          <td width="30%">
            <img class="sign-image" v-if="entrustData.inspUnitSign" :src="$imgUrl + entrustData.inspUnitSign" />
          </td>
        </tr>
        <tr>
          <td class="label">计划完成时间</td>
          <td colspan="3">
            {{ flowData.pfDate }}
          </td>
        </tr>
        <tr>
          <td class="label">转入实验室时间</td>
          <td>
            {{ flowData.syDate }}
          </td>
          <td class="label">实验室接样人</td>
          <td>
            {{ flowData.syrName }}
          </td>
        </tr>
        <tr>
          <td class="label">样品流转状态</td>
          <td colspan="3">
            <div class="checked-wrap state">
              <div>
                <span>{{ flowData.flowState >= 0 ? '☑' : '☐' }}</span>
                <span>待检</span>
              </div>
              <div>
                <span>{{ flowData.flowState >= 1 ? '☑' : '☐' }}</span>
                <span>在检</span>
              </div>
              <div>
                <span>{{ flowData.flowState >= 2 ? '☑' : '☐' }}</span>
                <span>已检</span>
              </div>
              <div>
                <span>{{ flowData.flowState >= 2 && entrustData.sampleDealWay == 3 ? '☑' : '☐' }}</span>
                <span>留样</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="label">试毕样品处理情况</td>
          <td colspan="3">
            <div class="checked-wrap">
              <div>
                <span>{{ entrustData.sampleDealWay == 0 ? '☑' : '☐' }}</span>
                <span>自取</span>
              </div>
              <div>
                <span>{{ entrustData.sampleDealWay == 1 ? '☑' : '☐' }}</span>
                <span>样品所有权转归受托方，并全权处置</span>
              </div>
              <div>
                <span>{{ entrustData.sampleDealWay == 2 ? '☑' : '☐' }}</span>
                <span>破坏性实验样品留存三个月</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="label">检验完成日期</td>
          <td colspan="3">
            {{ flowData.testDate }}
          </td>
        </tr>
      </table>
    </div>

    <div slot="footer" class="dialog-footer">
      <!-- TODO 下载流转单 -->
      <div>
        <el-button type="primary" @click="handleDownload">下载内部样品流转单</el-button>
        <el-button type="warning" @click="handleEditNote">编辑特殊说明</el-button>
      </div>
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </div>

    <!-- 编辑特殊说明 弹窗 -->
    <el-dialog
      :title="`编辑特殊说明【${entrustData.reportCode}】`"
      custom-class="append-dialog"
      :visible.sync="editNoteVisible"
      append-to-body
      :close-on-click-modal="false"
      width="600px"
    >
      <el-input
        ref="noteTextArea"
        type="textarea"
        v-model="formNote"
        placeholder="请输入特殊说明"
        :maxlength="500"
        :rows="4"
        clearable
      ></el-input>
      <span slot="footer">
        <el-button @click="editNoteVisible = false">取 消</el-button>
        <el-button :loading="editLoading" type="primary" @click="confirmEditNote">确 定</el-button>
      </span>
    </el-dialog>
  </drag-dialog>
</template>

<script>
import { getDictData } from '@/api/system';
import { editEntrustmentNote } from '@/api/entrust';
import { getFlowInfo, downloadFlowExcel } from '@/api/flow';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      flowSKH: '',
      detailLoading: false,
      entrustData: {},
      flowData: {},
      sampleInfoList: [],
      tesetItemData: [],
      editNoteVisible: false,
      formNote: '',
      editLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      this.getFlowSKH();
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  filters: {
    flowStateFilter(val) {
      switch (val) {
        case 0:
          return '待检';
        case 1:
          return '在检';
        case 2:
          return '已检';
        case 3:
          return '留样';
        default:
          return '';
      }
    }
  },
  methods: {
    async getFlowSKH() {
      const data = await getDictData({ code: 'SKH_flow' });
      this.flowSKH = data?.[0]?.value ?? '';
    },
    async getDetailData() {
      this.detailLoading = true;

      try {
        const { data } = await getFlowInfo({ entrustmentId: this.activeId });
        this.entrustData = data.entrustment ?? {};
        this.flowData = data.flow ?? {};
        const sampleInfoList = data.sampleInfoList || [];
        sampleInfoList.forEach((element, idx) => {
          const cnt = element.cnt;
          const noPrefix = element.itemNoMin.split('-').slice(0, -1).join('-');

          if (element.sampleName == '耐张线夹' || element.sampleName == '接续金具' || element.sampleName == '预紧绞丝') {
            element.itemNoMin = '/';
            element.itemNoMax = '/';
          } else {
            if (idx == 0) {
              element.itemNoMax = `${noPrefix}-${cnt.toString().padStart(3, '0')}`;
            } else {
              const prevCountCnt = sampleInfoList
                .slice(0, idx)
                .filter(
                  sample => sample.sampleName != '耐张线夹' && sample.sampleName != '接续金具' && sample.sampleName != '预紧绞丝'
                )
                .reduce((prev, curr) => {
                  return prev + curr.cnt;
                }, 0);

              element.itemNoMin = `${noPrefix}-${(prevCountCnt + 1).toString().padStart(3, '0')}`;
              element.itemNoMax = `${noPrefix}-${(prevCountCnt + cnt).toString().padStart(3, '0')}`;
            }
          }
        });
        this.sampleInfoList = sampleInfoList;

        const basisJson = JSON.parse(data.entrustment.basisJson || '[]');
        this.tesetItemData = basisJson;
      } finally {
        this.detailLoading = false;
      }
    },
    async handleDownload() {
      const res = await downloadFlowExcel({
        entrustmentId: this.activeId
      });
      // 解析文件名
      let filename = '内部流转单.xlsx';
      const contentDisposition = res.headers['content-disposition'];
      if (contentDisposition) {
        const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (matches && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
          filename = decodeURIComponent(filename);
        }
      }

      // 创建 Blob URL 并触发下载
      const blob = new Blob([res.data], { type: 'application/octet-stream' }); // 显式指定类型
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      this.$message.success('下载成功');
    },
    handleEditNote() {
      this.formNote = this.entrustData.note;
      this.editNoteVisible = true;
      this.$nextTick(() => {
        this.$refs.noteTextArea.focus();
      });
    },
    confirmEditNote() {
      this.$confirm(`您确认修改${this.entrustData.reportCode}的特殊说明吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.editLoading = true;
          try {
            await editEntrustmentNote({
              id: this.activeId,
              note: this.formNote
            });
            this.getDetailData();
            this.$message.success('修改成功！');
            this.editNoteVisible = false;
          } finally {
            this.editLoading = false;
          }
        })
        .catch(() => {});
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.top-code {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  font-size: 14px;
  color: #101010;
}

.sign-image {
  width: 80px;
  height: auto;
}

.checked-wrap {
  display: flex;
  align-items: center;
  justify-content: center;

  &.state {
    > div {
      margin-right: 70px;
    }
  }
  > div {
    display: flex;
    align-items: center;
    margin-right: 42px;
  }
  span:first-of-type {
    font-size: 20px;
    margin-bottom: 2px;
  }
}
</style>
